exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body{font-family:'Bai Jamjuree', sans-serif;margin:0;padding:0}*{box-sizing:border-box}*>*{box-sizing:border-box}\n", ""]);

